import React, { useState } from 'react'
import './sider.css'
import { Link, withRouter, useHistory } from 'react-router-dom'
import { Typography, Layout, Menu, Button } from 'antd'
import {
  CompassOutlined,
  HomeOutlined,
  LogoutOutlined,
  ProfileOutlined,
} from '@ant-design/icons'
import { useDispatch } from 'react-redux'
import { logout } from '../../redux/actions/user'

const { Sider } = Layout
const { Title } = Typography

// Redux actions

function CustomSider({ location }) {
  const dispatch = useDispatch()
  const history = useHistory()
  const theme = useState(localStorage.getItem('theme') || 'dark')[0] // default to dark theme or theme from localStorage

  return (
    <Sider
      className="gps-sidebar"
      theme={theme}
      breakpoint="lg"
      collapsedWidth="0"
      onBreakpoint={(broken) => {
        // console.log(broken)
      }}
      onCollapse={(collapsed, type) => {
        // console.log(collapsed, type)
      }}
    >
      <div className="gps-sidebar__brand">
        <div className="gps-sidebar__mark">
          <CompassOutlined />
        </div>
        <div>
          <Title level={4}>GPS History</Title>
          <span>Location console</span>
        </div>
      </div>
      <Menu
        className="gps-sidebar__menu"
        theme={theme}
        mode="inline"
        defaultSelectedKeys={['/']}
        selectedKeys={[location.pathname]}
      >
        <Menu.Item key="/" icon={<HomeOutlined />}>
          <Link to="/">Home</Link>
        </Menu.Item>
        <Menu.Item key="/how-to" icon={<ProfileOutlined />}>
          <Link to="/how-to">How to?</Link>
        </Menu.Item>
      </Menu>
      <div className="gps-sidebar__footer">
        <Button
          danger
          icon={<LogoutOutlined />}
          onClick={() => {
            dispatch(logout())
            history.push('/authenticate')
          }}
        >
          Logout
        </Button>
      </div>
    </Sider>
  )
}

export default withRouter(CustomSider)
